export const ALERT_TEXT = {
  argee: 'Tôi đã hiểu',
};
